import React, { useEffect, useRef, useState, } from 'react';
import { toast } from 'react-toastify'; //react toast 
import { API_SERVER, initializeFilterData } from '../../Utils'; //common Data
import { getCommonData, getMasterData } from '../../apiservices/CommonServices';
import { post } from '../../apiservices/service'; //services
import { useAuth } from '../../context/auth';
import { Token, dateFormate } from '../Common/Common';
import BlurLoader from "../Loder/BlurLoader"; //loder
import { AutoCompleteBox, DateBox, FormButton, SelectInputBox } from "../commoncomponents/InputBox";
import { Table } from '../commoncomponents/Table';

function LeaveApplication() {
    const inputrefs = useRef([]);
    const { user, sessionExpired } = useAuth();

    //token Data
    const TokenData = Token()

    //initial state
    const [recipe, setRecipe] = useState({
        ApplyFor: 'Self',
        Employee: '',
        ApplicationType: '',
        LeaveType: '',
        LeaveFromDate: '',
        LeaveFromType: '',
        LeaveToDate: '',
        LeaveToType: '',
        Reason: ''
    })
    const [EmployeeData, setEmployeeData] = useState([])
    const [loading, setLoading] = useState(false)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [isUpdate, setIsUpdate] = useState(false)
    const [errors, setErrors] = useState({});
    const [LeaveTypeData, setLeaveTypeData] = useState([]);
    const [tableData, setTableData] = useState({});



    const getEmployeeData = (value) => {
        let temp = {
            Type: "GetLeaveAppliedEmployee",
            Prefix: '',
            ContextKey: value ? value : 'Self',
            ContextKey2: ""
        }
        setLoading(true)
        getCommonData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setEmployeeData([])
                } else {
                    setLoading(false)
                    let data = res.dataList
                    setEmployeeData(data)
                }
            }
        });
    }

    const getLeaveTypeData = (value) => {
        let temp = {
            Type: "GetLeaveType",
            Prefix: '',
            ContextKey: value,
            ContextKey2: ""
        }
        setLoading(true)
        getMasterData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                } else {
                    setLoading(false)
                    let data = res.dataList
                    setLeaveTypeData(data)
                }
            }
        });
    }

    useEffect(() => {
        inputrefs.current['ddlApplyFor'].focus();
        document.title = 'Viva HRMS : Leave Application'
        getEmployeeData();
        GetLeaveRegisterTableData();
    }, [sortConfig, isUpdate])


    let EmpData = []
    for (let i = 0; i < EmployeeData.length; i++) {
        let mydata = EmployeeData[i]?.values
        EmpData.push(mydata)
    };

    //Change Handler
    const HandleChange = (prop, value) => {
        if (prop === "ApplicationType") {
            getLeaveTypeData(value);
        }
        setRecipe(recipe => ({ ...recipe, [prop]: value }))
    }

    const Validate = () => {
        setErrors({})
        let isValid = true;
        let validation = [

            { field: "ApplicationType", msg: 'Please Select Application Type.!' },
            { field: "LeaveType", msg: 'Please Select Leave Type.!' },
            { field: "LeaveFromDate", msg: 'Please Select Leave From Date.' },
            { field: "LeaveFromType", msg: 'Please Select Leave From Type.!' },
            { field: "LeaveToDate", msg: 'Please Select Leave To Date.' },
            { field: "LeaveToType", msg: 'Please Select Leave To Type.!' },
            { field: "Reason", msg: 'Please Enter Reason for Leave.' },
        ]

        if (recipe.ApplyFor !== 'Self') {
            validation.push({ field: "Employee", msg: 'Please Select Employee.!' })
        }

        validation.map(item => {
            if (!recipe[item.field] || recipe[item.field].length <= 0 || recipe[item.field] === '' || recipe[item.field] === '0') {

                setErrors(errors => ({ ...errors, [item.field]: item.msg }));
                isValid = false;
            }
            return item;
        });

        return isValid;
    }

    //handleSubmit Handler
    const handleSubmit = () => {
        if (Validate()) {
            setLoading(true)
            post(`${API_SERVER}api/Leave/LeaveApplication`, { ...TokenData, ...recipe, Employee: recipe.ApplyFor === 'Self' ? `${user.empCode} : ${user.employeeName}` : recipe.Employee }, (res) => {
                if (res && res.status) {
                    if (res.status === "ERROR") {
                        toast.error(res.message)
                        setLoading(false)
                    } else if (res.status === "EXPIRED") {
                        toast.error(res.message)
                        sessionExpired()
                    } else if (res.status === "UNAUTHORIZED") {
                        toast.error(res.message);
                        handleClear();
                        setLoading(false);
                    } else {
                        setLoading(false)
                        toast.success(res.message)
                        handleClear()
                    }
                }
            });
        }
    }

    //handle Get Leave Register Table Data 
    const GetLeaveRegisterTableData = (emp) => {
        post(`${API_SERVER}api/Leave/ShowLeaveRegister`, { ...TokenData, Employee: recipe.ApplyFor!=='Self' ? emp ? emp :'' : `${user.empCode} : ${user.employeeName}` }, (res) => {
            if (res && res.Status) {
                if (res.Status === "ERROR") {
                    setLoading(false)
                    setTableData({ ...res })
                } else if (res.Status === "EXPIRED") {
                    sessionExpired()
                    setLoading(false)
                } else {
                    setLoading(false)
                    setTableData({ ...res })
                }
            }
        });

    }

    //useEffect(() => {
    //   GetLeaveRegisterTableData();

    //}, [recipe.ApplyFor])

    //Reset Handler
    const handleClear = () => {
        setRecipe(recipe => ({
            ...recipe,
            ApplyFor: "Self",
            Employee: '',
            ApplicationType: '',
            LeaveType: '',
            LeaveFromDate: '',
            LeaveFromType: '',
            LeaveToDate: '',
            LeaveToType: '',
            Reason: ''
        }));
        setErrors({})
        setFilterData(filterData => ({ ...filterData, SearchText: '' }))
        setIsUpdate(!isUpdate)
        inputrefs.current['txtEmployee'].focus();
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0">Leave Application</h6>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <div className='col-6'>
                            <div className='row'>
                                <SelectInputBox
                                    divclassname='col-md-4 mb-1'
                                    label='Leave Apply for'
                                    inputrefs={inputrefs}
                                    required
                                    id="ddlApplyFor"
                                    value={recipe.ApplyFor}
                                    error={errors.ApplyFor}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current[recipe.ApplyFor === 'Self' ? 'ddlApplicationType' : 'txtEmployee'].focus() }
                                    }}
                                    onChange={(e) => {
                                        HandleChange('ApplyFor', e.target.value)
                                        getEmployeeData(e.target.value)
                                        if (e.target.value) setRecipe({ ...recipe, ApplyFor: e.target.value, Employee: '' })
                                    }}
                                    children={<>
                                        <option value="Self">Self</option>
                                        <option value="Team">Team</option>
                                    </>}
                                />
                                <AutoCompleteBox
                                    divclassname='col-md-4 mb-1'
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['ddlApplicationType'].focus() };
                                    }}
                                    label='Employee'
                                    placeholder="Employee"
                                    maxLength='100'
                                    disabled={recipe.ApplyFor === 'Self'}
                                    options={EmpData}
                                    id='txtEmployee'
                                    required={true}
                                    error={errors.Employee}
                                    inputValue={recipe.ApplyFor === 'Self' ? `${user.empCode} : ${user.employeeName}` : recipe.Employee ? recipe.Employee : ''}
                                    onInputChange={(event, newInputValue) => {
                                        HandleChange('Employee', newInputValue)
                                        GetLeaveRegisterTableData(newInputValue)
                                    }}
                                />
                                <SelectInputBox
                                    divclassname='col-md-4 mb-1'
                                    label='Application Type'
                                    inputrefs={inputrefs}
                                    required
                                    id="ddlApplicationType"
                                    value={recipe.ApplicationType}
                                    error={errors.ApplicationType}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['ddlLeaveType'].focus() };
                                    }}
                                    onChange={(e) => {
                                        HandleChange('ApplicationType', e.target.value)
                                        if (e.target.value) {
                                            setRecipe({ ...recipe, ApplicationType: e.target.value, LeaveFromDate: '', LeaveToDate: '' })
                                        }
                                    }}
                                    children={<>
                                        <option value="0">-- Select Application Type --</option>
                                        <option value="Absent">Against Absenteeism</option>
                                        <option value="Planned">Planned Leave</option>
                                    </>}
                                />
                                <SelectInputBox
                                    divclassname='col-md-4 mb-1'
                                    label='Leave Type'
                                    inputrefs={inputrefs}
                                    required
                                    error={errors.LeaveType}
                                    id="ddlLeaveType" value={recipe.LeaveType}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['txtLeaveFromDate'].focus() };
                                    }}
                                    onChange={(e) => HandleChange('LeaveType', e.target.value)}
                                    children={<>
                                        <option value="0">-- Select Leave Type --</option>
                                        {LeaveTypeData.map((opt, index) => <option key={index} value={opt.id} >{opt.name}</option>)}
                                    </>}
                                />
                                <div className="col-md-4 mb-1">
                                    <div className="row">
                                        <DateBox
                                            divclassname="col-7 "
                                            inputrefs={inputrefs}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') { inputrefs.current['ddlLeaveFromType'].focus() };
                                            }}
                                            maxDate={recipe.ApplicationType === "Absent" && new Date()}
                                            minDate={recipe.ApplicationType === "Planned" && new Date()}
                                            label='Leave From'
                                            id='txtLeaveFromDate'
                                            selected={recipe.LeaveFromDate === '' ? '' : new Date(recipe.LeaveFromDate)}
                                            maxLength='12'
                                            placeholder="Leave From"
                                            value={recipe.LeaveFromDate}
                                            onChange={(e) => {
                                                HandleChange('LeaveFromDate', dateFormate(e));
                                                if (e) setRecipe({ ...recipe, LeaveFromDate: dateFormate(e), LeaveToDate: '' });
                                            }}
                                            required
                                            error={errors.LeaveFromDate}
                                        />
                                        <SelectInputBox
                                            divclassname='col-5 mt-4 ps-0'
                                            inputStyle={{ marginTop: '0.1rem' }}
                                            inputrefs={inputrefs}
                                            required
                                            error={errors.LeaveFromType}
                                            id="ddlLeaveFromType" value={recipe.LeaveFromType}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') { inputrefs.current['txtLeaveToDate'].focus() };
                                            }}
                                            onChange={(e) => HandleChange('LeaveFromType', e.target.value)}
                                            children={<>
                                                <option value="0">--Select--</option>
                                                <option value="1">Full Day</option>
                                                <option value="3">Half Day</option>
                                            </>}
                                        />

                                    </div>
                                </div>

                                <div className="col-md-4 mb-1 ">
                                    <div className="row">
                                        <DateBox
                                            divclassname="col-7"
                                            inputrefs={inputrefs}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') { inputrefs.current['ddlLeaveToType'].focus() };
                                            }}
                                            minDate={new Date(recipe.LeaveFromDate)}
                                            maxDate={recipe.ApplicationType === "Absent" && new Date()}
                                            label='Leave To'
                                            id='txtLeaveToDate'
                                            selected={recipe.LeaveToDate === '' ? '' : new Date(recipe.LeaveToDate)}
                                            maxLength='12'
                                            placeholder="Leave To"
                                            value={recipe.LeaveToDate}
                                            error={errors.LeaveToDate}
                                            onChange={(e) => HandleChange('LeaveToDate', dateFormate(e))}
                                            required
                                        />
                                        <SelectInputBox
                                            divclassname='col-5 mt-4 ps-0'
                                            inputStyle={{ marginTop: '0.1rem' }}
                                            inputrefs={inputrefs}
                                            required
                                            error={errors.LeaveFromType}
                                            id="ddlLeaveToType" value={recipe.LeaveToType}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') { inputrefs.current['txtReason'].focus() };
                                            }}
                                            onChange={(e) => HandleChange('LeaveToType', e.target.value)}
                                            children={<>
                                                <option value="0">--Select--</option>
                                                <option value="1">Full Day</option>
                                                <option value="2">Half Day</option>
                                            </>}
                                        />
                                    </div>
                                </div>
                                <div className={`col-md-4 mb-1`} >
                                    <label> Reason <span style={{ color: "red" }}> *</span>
                                        <textarea
                                            ref={ref => (inputrefs.current['txtReason'] = ref)}
                                            className="form-control mt-1"
                                            id="txtReason"
                                            name="txtReason"
                                            rows={2} cols={100}
                                            placeholder="Enter Reason..."
                                            value={recipe.Reason}
                                            onChange={(e) => HandleChange('Reason', e.target.value)}
                                        /></label>
                                    <div className="error-msg">{errors.Reason}</div>
                                </div>

                                <FormButton
                                    Export={false}
                                    SaveText='Apply'
                                    saveButtonIcon='fa-check'
                                    handleSubmit={handleSubmit}
                                    handleClear={handleClear}
                                />

                            </div>
                        </div>
                        <div className='col-6'>
                            
                            {tableData.Message !== "No Record Found" && (
                                <Table
                                    headingText="Leave Register"
                                    Filter={false}
                                    Action={false}
                                    Token={TokenData}
                                    PageName=""
                                    showTotalRecord={false}
                                    tableData={tableData}
                                    loading={loading}
                                />
                            )}
                        </div>
                    </div>
                </div >

                {loading && <BlurLoader />}
            </div >
        </>
    )
}

export default LeaveApplication